import { UserStar } from 'lucide-react';

import { Dialog, Skeleton, useDialog } from '@components/primitives';

import { UserObject } from '@api/types';
import { Command } from '@components/features/CommandMenu';
import { NavigationDropdown } from '@components/features/Layout/Navigation/Dropdown';
import { Restricted } from '@components/features/Restricted';
import { UserAvatar } from '@components/features/UserAvatar';
import * as Gateways from '@routes/Gateways';

import { UserRoleUpdateModal } from './UserRoleUpdate';

import css from './styles.module.css';

export function UserActions({
  user,
  children,
}: {
  user: UserObject;
  children: React.ReactNode;
}) {
  const updateUserRoleDialog = useDialog();

  return (
    <>
      <Dialog state={updateUserRoleDialog}>
        <Dialog.Header title={`Update user role for ${user?.name}`} />
        <Dialog.Body>
          <UserRoleUpdateModal userToChange={user} />
        </Dialog.Body>
      </Dialog>

      <NavigationDropdown trigger={children}>
        <NavigationDropdown.Section>
          <NavigationDropdown.Item
            icon={
              <span className={css.userAvatar}>
                <UserAvatar uid={user.id} fallback={user.name} />
              </span>
            }
            label={
              user ? (
                <span className={css.userName}>{user.name}</span>
              ) : (
                <Skeleton width={96} height={12} />
              )
            }
          />
        </NavigationDropdown.Section>
        <NavigationDropdown.Section label="Actions">
          <Restricted
            allow="superuser"
            side="right"
            render={
              <NavigationDropdown.Item
                icon={<UserStar />}
                label="Change role"
                onClick={updateUserRoleDialog.open}
              />
            }
          />
        </NavigationDropdown.Section>
      </NavigationDropdown>

      <Gateways.RequireSuperuser fallback={null}>
        <Command
          type="action"
          id="user-manage-features"
          label="Change role"
          icon={<UserStar />}
          context="user"
          group={user.name}
          onSelect={updateUserRoleDialog.open}
        />
      </Gateways.RequireSuperuser>
    </>
  );
}
